import type { ReactNode } from 'react';

import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@/_components';
import { useIsMobile } from '@/_shared/hooks/use-mobile';

const SPLIT_HEIGHT_EXTRA_PX = 30;
const MIN_OUTER_HEIGHT_BASE_PX = 576;
const BOTTOM_PX_WIDE = 265;
const BOTTOM_PX_NARROW = 315;
const BOTTOM_MIN_PX = 130;
const BOTTOM_MAX_PX = 520;

type InvoicesSplitViewProps = {
  topContent: ReactNode;
  bottomContent: ReactNode;
  className?: string;
};

export function InvoicesSplitView({ topContent, bottomContent, className }: InvoicesSplitViewProps) {
  const isNarrow = useIsMobile(1920);
  const bottomBase = isNarrow ? BOTTOM_PX_NARROW : BOTTOM_PX_WIDE;
  const bottomDefault = bottomBase + SPLIT_HEIGHT_EXTRA_PX;

  return (
    <div
      className={className}
      style={{
        height: `calc(70vh + ${SPLIT_HEIGHT_EXTRA_PX}px)`,
        minHeight: MIN_OUTER_HEIGHT_BASE_PX + SPLIT_HEIGHT_EXTRA_PX,
      }}
    >
      <ResizablePanelGroup id="invoices-main-vertical-split" orientation="vertical">
        <ResizablePanel id="invoices-split-table" minSize="35%" groupResizeBehavior="preserve-relative-size">
          <div className="h-full min-h-0 pt-2">{topContent}</div>
        </ResizablePanel>
        <ResizableHandle withHandle className="bg-c-border h-2 after:h-4" />
        <ResizablePanel
          id="invoices-split-bottom"
          defaultSize={bottomDefault}
          minSize={BOTTOM_MIN_PX + SPLIT_HEIGHT_EXTRA_PX}
          maxSize={BOTTOM_MAX_PX + SPLIT_HEIGHT_EXTRA_PX}
          groupResizeBehavior="preserve-pixel-size"
        >
          <div className="h-full min-h-0">{bottomContent}</div>
        </ResizablePanel>
      </ResizablePanelGroup>
    </div>
  );
}
